import cloneDeep from 'lodash/cloneDeep'
import AccountType from '@/constants/user/AccountType'
import Avatar from '@/models-ts/user/Avatar'

type Rating = { category: number; rate: number }

export default class Review {
  createdAt: string
  id: number
  type: number
  userId: number
  userType: AccountType
  avatar: Avatar
  userName: string
  userAvgReview: string
  userAvgReputation: string
  reviewsCount: number
  text: string
  ratings: Array<Rating>
  gig_job_id: number | null

  constructor(data: Partial<Review>) {
    Object.assign(this, cloneDeep(data))
  }

  static fromServer(props: LX.Review) {
    return new Review({
      createdAt: props.created_at,
      id: props.id,
      type: props.type,
      userId: props.from_user_id,
      userType: props.meta.from_user?.type || AccountType.USER_ACCOUNT_SIMPLE,
      userName: props.meta.from_user?.name || '',
      avatar: Avatar.fromServer(props.meta.from_user?.avatars || []),
      userAvgReview: Number(props.meta.from_user?.avg_reviews || 0).toFixed(2),
      userAvgReputation: Number(props.meta.from_user?.avg_reputation || 0).toFixed(2),
      reviewsCount: props.meta.from_user?.reviews_count || 0,
      text: props.text || '',
      ratings: props.relations.Rate || [],
      gig_job_id: props.gig_job_id || null,
    })
  }
}
